import { ChangeDetectorRef ,ViewRef,Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { FormDialogFormulaireWithSFComponent } from '../../../../../motor-form-atyl/form-atyl-components/form-dialog/form-dialog-formulaire-with-sf/form-dialog-formulaire-with-sf.component'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { DialogService, StateService,DossierService

 } from '../../../../../services'



import {
	Observable,
	BehaviorSubject,	
} from "rxjs";

const KEY = 'dossier-statistique'

@Component({
  selector: 'atyl-dossier-statistique',
  templateUrl: './dossier-statistique.component.html',
  styleUrls: ['./dossier-statistique.component.scss']
})
@Stringable({
  path: 'views/partials/content/dossier/dossier-statistique',
  key: KEY,
})
export class DossierStatistiqueComponent implements OnInit {

  @Input() refresh:BehaviorSubject<number>=new BehaviorSubject<number>(0);
  
  loading:boolean=false;
  
  @StringableValues(KEY) strings: any
  
  @Input() inline:boolean =true;
  @Input() tiers: any;
  @Input() dossier: any;

  stats:any[]=[];
  
  refreshEvent:any;

  constructor(
    private changeDetector: ChangeDetectorRef,
    private stateService: StateService,
    private dialogService: DialogService,
    private dossierService: DossierService,
    private changeDetectorRef: ChangeDetectorRef
  
  ) { }

  ngOnInit() {
	  console.log("DossierStatistiqueComponent init",this.dossier,this.tiers);	
	  
	  this.refreshEvent=this.refresh.subscribe((ID)=>{
		console.log("DossierStatistiqueComponent refresh",this.tiers,ID)
		if (this.tiers.statistiques!=undefined){
						this.stats=this.tiers.statistiques;
						console.log("DossierStatistiqueComponent ",this.stats);
						this.loading=false;
						this.detectChanges();
					} else {
			if (ID 
				  &&  this.dossier!=undefined
				   && this.dossier.ID!=undefined
				   && this.dossier.ID==ID
				    ) {
					  
					this.loadStat();
				}
			}	
		 });
	  
	 if (this.dossier!=undefined)	
      {	//this.loadStat();
		
	  }
     else {
		 if (this.tiers!=undefined 
		  ) {
			if (this.tiers.statistiques!=undefined){
				this.stats=this.tiers.statistiques;
				console.log("DossierStatistiqueComponent ",this.stats);
				this.loading=false;
				this.detectChanges();
			} else {
			/*	if (this.tiers.dossierID!=undefined) {
				   let _ops={}; 		  
				  this.dossierService.get(this.tiers.dossierID,_ops).subscribe(
					(res: JSONRpcResponse) => {
						
						this.dossier=res.result;
						this.loadStat();
					}
					);
					
			}	*/
			}	
		}
	 }
    
  }
  
  ngOnDestroy() {
	if (this.refreshEvent) {
		console.log("DossierStatistiqueComponent destroy",this.refreshEvent,this.dossier,this.tiers);	
		  
		 
  		this.refreshEvent.unsubscribe();
  	}
        
   }
  
   loadStat() {
	   console.log("DossierStatistiqueComponent ",this.dossier);	
	   this.stats=[];
	   if (this.dossier.ID!=undefined) {
		   let _ops={};
		   this.loading=true;
		   this.dossierService.getStatistiqueList(this.dossier.ID,_ops).subscribe(
			(res: JSONRpcResponse) => {
				console.log("DossierStatistiqueComponent ",res.result);
				this.stats=res.result;
				this.loading=false;
				this.detectChanges();
			}
		);
	   }
	   
	   	
   }
  
   detectChanges() {
        setTimeout(() => {
            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                this.changeDetectorRef.detectChanges()
            }
        })
    }
    
   	

}
